import { Screen } from '~/screens/top-banners/[id]/edit';

export const TopBannersEdit: React.FC = () => <Screen />;
